import { mapMonolithCartToStripeCart } from '@app/components/Stripe';
import {
  useCartAndDeliveryDatesDataContext,
  useUpdateShippingDetails,
} from '@app/data/clients/cartCheckoutClient';
import { UpdateShippingDetailsAPIRequest } from '@app/types/monolith/types';
import { useCallback } from 'react';

export const useStripeShippingAddressChangeHandler = () => {
  const { dispatch, client } = useCartAndDeliveryDatesDataContext();

  const { handler: handleUpdateShippingDetails } = useUpdateShippingDetails({
    client,
    dispatch,
  });

  const handleShippingAddressChange = useCallback(
    async (shippingAddress: UpdateShippingDetailsAPIRequest) => {
      const result = await handleUpdateShippingDetails(shippingAddress);

      if (result.state === 'FAILED' || !result?.data) {
        const errorMessage =
          result.errors?.[0]?.exception || 'Failed to update shipping address';
        throw new Error(errorMessage);
      }

      return mapMonolithCartToStripeCart(result.data);
    },
    [handleUpdateShippingDetails]
  );

  return { handleShippingAddressChange };
};
